export default "__VITE_ASSET__DrqIl5_T__"